import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import BoundaryNodeRule from '../algorithm/BoundaryNodeRule';
import GeometryGraph from '../geomgraph/GeometryGraph';
import RobustLineIntersector from '../algorithm/RobustLineIntersector';
var GeometryGraphOperation = /*#__PURE__*/function () {
  function GeometryGraphOperation() {
    _classCallCheck(this, GeometryGraphOperation);
    GeometryGraphOperation.constructor_.apply(this, arguments);
  }
  _createClass(GeometryGraphOperation, [{
    key: "getArgGeometry",
    value: function getArgGeometry(i) {
      return this._arg[i].getGeometry();
    }
  }, {
    key: "setComputationPrecision",
    value: function setComputationPrecision(pm) {
      this._resultPrecisionModel = pm;
      this._li.setPrecisionModel(this._resultPrecisionModel);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._li = new RobustLineIntersector();
      this._resultPrecisionModel = null;
      this._arg = null;
      if (arguments.length === 1) {
        var g0 = arguments[0];
        this.setComputationPrecision(g0.getPrecisionModel());
        this._arg = new Array(1).fill(null);
        this._arg[0] = new GeometryGraph(0, g0);
      } else if (arguments.length === 2) {
        var _g = arguments[0],
          g1 = arguments[1];
        GeometryGraphOperation.constructor_.call(this, _g, g1, BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE);
      } else if (arguments.length === 3) {
        var _g2 = arguments[0],
          _g3 = arguments[1],
          boundaryNodeRule = arguments[2];
        if (_g2.getPrecisionModel().compareTo(_g3.getPrecisionModel()) >= 0) this.setComputationPrecision(_g2.getPrecisionModel());else this.setComputationPrecision(_g3.getPrecisionModel());
        this._arg = new Array(2).fill(null);
        this._arg[0] = new GeometryGraph(0, _g2, boundaryNodeRule);
        this._arg[1] = new GeometryGraph(1, _g3, boundaryNodeRule);
      }
    }
  }]);
  return GeometryGraphOperation;
}();
export { GeometryGraphOperation as default };